import styles from './treatment-sections.module.css';
import { useTranslation } from '@/contexts/i18n-context';
import { GetTreatmentPlanResponse } from '@/api/api.schemas';
import { Section } from '../containers/section';
import { ExpandableInfo } from '@/components/encounter/review/expandable-info';
import { OtcSection } from './otc-section';
import { AboutDiagnosisSection } from './about-diagnosis-section';
import { PrescriptionsSection } from './prescriptions-section';

interface TreatmentSectionProps {
  treatmentPlan: GetTreatmentPlanResponse;
}

const translationBase = 'visit.treatmentPlan.treatment';

export function TreatmentSection({ treatmentPlan }: TreatmentSectionProps) {
  const { t } = useTranslation();

  return (
    <Section title={t(`${translationBase}.title`)}>
      <PrescriptionsSection
        prescriptions={treatmentPlan.prescriptions}
        className={styles.treatmentSubSection}
      />

      <OtcSection
        otcProducts={treatmentPlan.otcProducts}
        otcProductsAds={treatmentPlan.otcProductsAds}
        ads={treatmentPlan.ads}
        className={styles.treatmentSubSection}
      />

      {treatmentPlan.diagnosisName && (
        <AboutDiagnosisSection
          aboutYourDiagnosis={treatmentPlan.aboutYourDiagnosis}
          diagnosisName={treatmentPlan.diagnosisName}
          counseling={treatmentPlan.counseling}
          treatmentDetails={treatmentPlan.treatmentDetails}
          className={styles.treatmentSubSection}
        />
      )}

      {treatmentPlan.additionalAdvices.length > 0 && (
        <ExpandableInfo
          title={t('visit.treatmentPlan.additionalAdvice.title')}
          className={styles.treatmentSubSection}
        >
          {treatmentPlan.additionalAdvices.map((advice, index) => (
            <p key={index}>{advice}</p>
          ))}
        </ExpandableInfo>
      )}
    </Section>
  );
}
